// ProjectsConfig.js - קונפיגורציה של הפרויקטים של לילך מורד

export const projectsConfig = [
  {
    id: 1,
    title: "בית בגן יבנה",
    subtitle: "עיצוב פנים מלא",
    category: "מגורים",
    folderName: "לילך מורד גן יבנה",
    imageCount: 139,
    thumbnailIndex: 55,
    heroImages: [35, 60, 90],
    excludeRange: [1, 26],
    extension: "webp",
    description: `פרויקט עיצוב פנים מקיף לבית פרטי בגן יבנה.
שילוב של חומרים טבעיים עם קווים נקיים שיוצרים חלל חם ומזמין.
כל פינה בבית תוכננה מתוך הקשבה לצרכים של המשפחה ולשגרת היומיום שלהם.`,
  },
  {
    id: 2,
    title: "משרד אדל",
    subtitle: "עיצוב חלל עבודה",
    category: "מסחרי",
    folderName: "משרדי אדל סופיות",
    imageCount: 36,
    thumbnailIndex: 12,
    heroImages: [11, 15, 35],
    extension: "webp",
    description: `עיצוב משרד מודרני שמשלב פונקציונליות עם אסתטיקה.
חלל שמעודד יצירתיות ופרודוקטיביות, עם תשומת לב לפרטים הקטנים שעושים את ההבדל.`,
    taggedImages: {
      folderName: "הדמיות משרד אדל",
      imageCount: 4,
      extension: "webp",
      tag: "הדמייה ראשונית שהלקוחה קיבלה",
    },
  },
  {
    id: 3,
    title: "פרויקט אשדוד",
    subtitle: "הדמיות עיצוב",
    category: "מגורים",
    folderName: "הדמיות פרוייקט אשדוד",
    imageCount: 10,
    thumbnailIndex: 1,
    heroImages: [1, 3, 5],
    extension: "webp",
    description: `פרויקט מגורים באשדוד עם חזון עיצובי ייחודי.
שילוב של גוונים חמים וחומרים איכותיים שיוצרים תחושה ביתית ומפנקת.`,
  },
  {
    id: 4,
    title: "פרויקט ירוחם",
    subtitle: "עיצוב ותכנון",
    category: "מגורים",
    folderName: "הדמיות פרוייקט ירוחם",
    imageCount: 16,
    thumbnailIndex: 4,
    heroImages: [1, 4, 7],
    extension: "webp",
    description: `פרויקט עיצוב שמכבד את הסביבה המדברית ומשלב אותה בתוך הבית.
חומרים טבעיים וגוונים ארציים שיוצרים הרמוניה בין הפנים לחוץ.`,
  },
  {
    id: 5,
    title: "חלל ספורט פונקציונלי",
    subtitle: "עיצוב חלל ספורט",
    category: "מסחרי",
    folderName: "פילאטיס",
    imageCount: 11,
    thumbnailIndex: 8,
    heroImages: [1, 5, 8],
    extension: "webp",
    description: `עיצוב סטודיו פילאטיס שמשדר שלווה ורוגע.
חלל שמזמין תנועה, עם תאורה טבעית וחומרים שמרגיעים את החושים.`,
  },
];
